import { createGlobalStyle } from 'styled-components';

const base = {
  gridSize: 12,
  gutterWidth: 1,
  outerMargin: 2,
};

const fontFamily = `'Red Hat Text', sans-serif`;
const fontFamilyMedium = `'Red Hat Text', sans-serif`;
const fontFamilySecondary = `'Playfair Display', serif`;
const fontFamilySecondaryMedium = `'Playfair Display', serif`;
const fontFamilyTertiary = `'Playfair Display', serif`;
const fontFamilyTertiaryMedium = `'Playfair Display', serif`;

export const colors = {
  black: '#000000',
  bianca: '#FDFBF5',
  emperor: '#535353',
  emperor38: 'rgba(84, 77, 77, 0.38)',
  ferra: '#e5e1d6',
  ferra5: 'rgba(229, 225, 214, 0.5)',
  ferra10: 'rgba(108, 80, 71, 0.1)',
  ferra50: 'rgba(108, 80, 71, 0.5)',
  ferraLight: 'rgba(229, 225, 214, 0.4)',
  black00: 'rgba(0,0,0,0)',
  black12: 'rgba(0,0,0,.12)',
  black72: 'rgba(0,0,0, .72)',
  black92: 'rgba(0,0,0, .92)',
  black20: 'rgba(0, 0, 0, 0.2)',
  black06: 'rgba(0, 0, 0, 0.06)',
  flamePea: '#DF5239',
  red: '#DE0000',
  gray: '#666666',
  gray50: 'rgba(133, 133, 133, 0.5)',
  grayDark: '#544d4d',
  grayDark80: 'rgba(84,77,77,0.08)',
  green: '#009b76',
  mineShaft: '#333333',
  mineShaftDarker: '#2a2a2a',
  mineShaftDarker04: 'rgba(42,42,42,0.4)',
  mineShaftDarker4: 'rgba(42,42,42,0.04)',
  mineShaftDarker50: 'rgba(42,42,42,0.5)',
  pearlBush: '#EDE6DB',
  softAmber50: 'rgba(214,199,182,0.5)',
  softAmber20: 'rgba(27, 48, 111, 0.07)',
  quarterPearlLusta: '#FFFDF7',
  white: '#FFFFFF',
  white50: 'rgba(255,255,255,0.5)',
  white37: 'rgba(255,255,255,0.37)',
  white95: 'rgba(255,255,255,0.95)',
  white9: 'rgba(255,255,255,0.09)',
  white4: 'rgba(255,255,255,0.04)',
  whiteCreamy: '#faf9f7',
  whiteGrey: '#f3f2f0',
  cafeRoyale: '#998255',
  golden: '#b19662',
  goldenDarker: '#998255',
  golden5: 'rgba(177, 150, 98, 0.5)',
  golden36: 'rgba(177, 150, 98, 0.36)',
  golden24: 'rgba(177, 150, 98, 0.24)',
  goldenText: '#9b907a',
  metalGolden: '#836B3B',
  goldenButton: '#c1aa90',
  sorrelBrown: '#c9b287',
  grandis: '#ffd585',
  grandis15: 'rgb(255,213,133, 0.15)',
  indianKhaki: '#c5b88e',
  purple: '#ac3d5b',
  brightSun: '#facb47',
  whiteLinen: '#f7f3e7',
  merino: '#f7f1e9',
  lightGrey: 'rgba(214,199,182, 0.2)',
  lightGrey15: 'rgba(216,216,216, 0.15)',
  lightGreyHex: '#d8d8d8',
  alabaster: '#fafafa',
  alabaster6: 'rgba(146, 142, 142, 0.06)',
  alabasterDarker: '#fcfcfc',
  chambray: '#3A5593',
  dustyGray: '#979797',
  dustyGray20: 'rgba(151,151,151, 0.2)',
  dustyGray18: 'rgba(151,151,151, 0.18)',
  hibiscus: '#c22e62',
  hibiscus20: 'rgba(194,46,98, 0.2)',
  mercury: '#e9e9e9',
  mercuryLight: '#e5e5e5',
  biscay: '#123D84',
  biscay10: 'rgba(18, 61, 132, 0.1)',
  biscayDark: '#1B306F',
  whiteOpacity: 'rgba(42, 42, 42, 0.02)',
  springWood: '#FBFAF7',
  fireBush: '#E58332',
  greenHaze: '#009c5c',
  vinrouge: '#95415e',
  ferraGrayDark18: 'rgba(84,77,77,0.18)',
  bizarre: '#efe2d7',
  grayNickel: '#c3c3c2',
  athensGray: '#EFF0F4',
  pampasDark: '#f3f1ec',
  pampas: '#F8F5F3',
  quillGray: '#dedddb',
  marzipan: '#f9dca3',
  putty: '#E8CB91',
  albescentWhite: '#f5e8cf',
  potPourry25: 'rgba(241, 227, 216, 0.25)',
  roseBudCherry: '#3ebfbf',
  razzmatazz: '#ec1359',
  lowGrey: '#929292',
  mediumGrey: '#5f5f5f',
  shiraz: '#BD0F47',
  shirazDark: '#a40733',
  shiraz83: 'rgba(164, 7, 51, 0.83)',
  cyprus: '#003e40',
  gallery: '#EBEAEA',
  jaffa: '#ec983c',
  jaffa20: 'rgba(236, 152, 60, 0.2)',
  silver: '#CCCCCC',
  keppel: '#32B397',
  keppel40: 'rgba(50,179,151, 0.4)',
  solidPink: '#903849',
  shiny: '#385DCB',
  redBright: '#B10104',
  mateak26: '#E7E0D1',
  teak15: 'rgba(215,200,183, 0.15)',
  ferraV2: '#6c5047',
  dawnPink: '#F2ECE4',
  tana40: 'rgba(223,214,193, 0.4)',
  silverChalice: '#AAAAAA',
  yoBarTitle: '#186069',
  roseWood: '#570000',
  temptress: '#470000',
  heroPromoButton: '#faa21b',
  pearlLusta: '#FBEDDD',
  concrete: '#faf9f7',
  concreteLight: '#FBF2DF',
  concretDarker: '#f2f2f2',
  cinderella: '#FCDFD9',
  faluRed: '#791414',
  woodyBrown: '#43302D',
  froly: '#F7827D',
  peachSchnapps: '#FFDBD4',
  elm: '#1a917b',
  doveGray: '#626262',
  tundora: 'rgba(64, 64, 64, 1)',
  tundora50: 'rgba(64, 64, 64, 0.5)',
  regalBlue: '#003a75',
  drawerBg: '#F4F4F4',
  blueZodiac: '#0e1e4e',
  footerBgColor: '#2a2a2a',
  textFooterColor: '#b19662',
  textFooterColorLight: 'rgba(177, 150, 98, 0.36)',
  headerBackground: '#2a2a2a',
  headerFontColor: '#FFFFFF',
  terracota: '#e26d53',
  cararra: '#e9e8e6',
  valencia: '#d73d3f',
  coronaBackgroundColor: '#E8CB91',
  desert: '#f7f6f5',
  potpourri41: 'rgba(241, 227, 216, 0.41)',
  bridalHeath: '#FFFAF0',
  yellowMetal: '#7f693f',
  aquaHaze: '#ebf3f3',
  carouselPink: '#fdf3f5',
  crimson: '#d41150',
  linkWater: '#F0F5FC',
  linkWater12: 'rgba(0, 42, 105, 0.12)',
  chathamsBlue: '#123D84',
  systemCrimson: '#1c7872',
  linen: '#fcf5f0',
  darkBoulder: '#6D6D6D',
  boulder: '#767676',
  boulder50: 'rgba(123,121,121,0.5)',
  jellyBean: '#276990',
  foam: '#e7fdf5',
  compactDisc: '#cdcdcd',
  discCompact: '#dcdcdc',
  pageBackground: '#e5e1d6',
  chathamsBlueLight: '#EEF8FE',
  fuzzyWuzzyBrown: '#c24754',
  flushMahogany: '#c33745',
  wispPink: '#fce8ea',
  elfGreen: '#0a8074',
  eggBlue: '#08C6B4',
  midnightBlue: '#002A69',
  yellow: '#F6FB00',
  dynamite: '#c4c4c4',
  alto: '#E0DEDE',
  capePalliser: '#8E723E',
  geyser: '#DCE0E5',
  loblolly: '#B8C2CC',
};

const secondaryColors = {
  blue10: '#ade7ff',
  blue20: '#61bcff',
  darkGrey: '#AEADAD',
};

const breakpoints = {
  xs: '0px',
  ms: '360px',
  sm: '600px',
  md: '960px',
  mdLegacy: '1199px',
  lg: '1280px',
  xl: '1920px',
};

interface StyleClosetTheme {
  base: {};
  breakpoints: {};
  fontFamily: string;
  fontFamilyMedium: string;
  fontFamilySecondary: string;
  fontFamilySecondaryMedium: string;
  fontFamilyTertiary: string;
  fontFamilyTertiaryMedium: string;
  colors: { [key in keyof typeof colors]: string };
  secondaryColors: { [key in keyof typeof secondaryColors]: string };
}

const theme: StyleClosetTheme = {
  base,
  breakpoints,
  fontFamily,
  fontFamilyMedium,
  fontFamilySecondary,
  fontFamilySecondaryMedium,
  fontFamilyTertiary,
  fontFamilyTertiaryMedium,
  colors,
  secondaryColors,
};

export const GlobalStyle = createGlobalStyle`
  *, :after, :before {
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  }
  html {
    &, input, button, select, textarea, h1, h2, h3, h4, h5, h6, .MuiTab-root{
      font-family: ${fontFamily};
    }
    hr{
      margin-top: 10px;
      margin-bottom: 10px;
      border: 0;
      border-top: 1px solid ${colors.silver};
    }
    header {
      margin-top: 0;
      width: 100%;
      top: 0;
      position: fixed;
      z-index: 15;
    }
    body{
      font-size: 1rem;
      line-height: 1.5;
      margin: 0;
      &.disableScroll {
        overflow: hidden;
      }
      .slick-track {
        will-change: transform;
      }
      .slick-slide{
        > div{
          > div{
            outline: none!important;
          }
        }
      }
    }
    a {
      text-decoration: none;
      color: inherit;
    }
    button {
      cursor: pointer;
    }
    input {
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
    }
    svg:not(:root) {
      overflow: hidden;
    }
    p {
      margin: 0 0 10px;
    }
    ul {
      margin-top: 0;
      margin-bottom: 10px;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: 500;
      line-height: 1.1;
    }
    h1,
    h2,
    h3 {
      margin-top: 20px;
      margin-bottom: 10px;
    }
    h4,
    h5,
    h6 {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    h1 {
      font-size: 36px;
    }
    h2 {
      font-size: 30px;
    }
    h3 {
      font-size: 24px;
    }
    h4 {
      font-size: 18px;
    }
    h5 {
      font-size: 14px;
    }
    h6 {
      font-size: 12px;
    }
    input,
    button,
    select,
    textarea {
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
    }
  }
  #campaign,
  #home,
  #destination,
  #destinationInfo,
  #destinationLandings {
    background-color: white;
    min-height: 100vh;
  }
  #checkout {
    padding: 85px 16px 32px 16px;
    @media (max-width: 479px) {
      padding: 40px 0 34px 0;
    }
  }
  .zindexHeader{
    z-index: 1600;
  }
  .zindexHeaderUnset{
    z-index: 15;
  }
  .lazyHeroPlaceholder {
    filter: blur(1rem);
    height: 100%!important;
    width: 100%!important;
  }
  .lazyPlaceholder {
    filter: blur(1rem);
    height: calc(100% + 2rem)!important;
    width: calc(100% + 2rem)!important;
    margin-left: -1rem;
    margin-top: -1rem;
  }

  /* legacy ICOMOON icons */
  @font-face {
    font-family: 'icomoon';
    src: url("data:application/x-font-ttf;charset=utf-8;base64,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") format('truetype');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
`;

export { theme };
